import PageLoadAnimation from "../page-load-animation";

class AsyncShippingChecks {
	constructor() {
		this._init()
	}

	_init() {
		this.elForm = document.querySelector('[data-checkout]');
		this.currencySymbol = this.elForm.dataset.currencySymbol;

		this.loading = new PageLoadAnimation(false)
		this.postalCodeValue = ''
		this.countryValue = ''
		this.timeout = null

		this.elValues = document.querySelectorAll('[data-value-2]')
		this.elShipValue = document.querySelector('[data-ship-value]')
		this.elResult = document.querySelector('[data-result]')

		this.el = document.querySelector('[data-shipping-methods]')
		this.url = this.el.dataset.shippingMethods
		this.dstEl = document.querySelector('[data-shipping-methods-dst]')
		this.postalCodeEl = document.querySelector('[data-postal-code-shipping]')
		this.countryEl = document.querySelector('[data-country-shipping]')

		if (this.postalCodeEl) {
			this.postalCodeEl.addEventListener('change', () => {
				this.updateData()
			})
		}
		if (this.countryEl) {
			this.countryEl.addEventListener('change', () => {
				this.updateData()
			})
		}
		this.el.querySelectorAll('input').forEach(elInput => elInput.addEventListener('change', () => {
			this.updateData()
		}))
		setTimeout(() => this.updateData(), 300)
	}

	updateData() {
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.countryValue = null
			this.postalCodeValue = null

			if (this.countryEl)
				this.countryValue = this.countryEl.value

			if (this.postalCodeEl)
				this.postalCodeValue = this.postalCodeEl.value
		}, 500)
	}

	refresh() {
		this.loading.toggleLoading(true)
		this.fetch()
			.then((data) => {
				if (!data.ok) {
					this.loading.toggleLoading(false)
					alert(data.error)
					console.error(data)
					return
				}
				this.loading.toggleLoading(false)
				console.log(data)
			})
	}

	fetch() {
		const id = this.getElActionId()
		let json = JSON.stringify({
			'shipping-id': id,
			'country': this.countryValue,
			'postal-code': this.postalCodeValue
		})
		return fetch(window.location.origin + this.url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: json
		}).then(response => {
			return response.json()
		})
	}

	getElActionId(el) {
		return this.el.querySelector('input:checked').getAttribute('id').split('-').pop()
	}

	runChecks() {
		return new Promise((resolve, reject) => {
			this.loading.toggleLoading(true)
			this.fetch()
				.then((data) => {
					if (!data.ok) {
						this.loading.toggleLoading(false)
						alert(data.error)
						reject(data.error)
						return
					}
					this.loading.toggleLoading(false)
					this.elShipValue.dataset.value = data.price
					this.elShipValue.innerHTML = data.price.toFixed(2).replace('.', ',') + ' ' + this.currencySymbol
					this.updateResultValues()
					resolve(data)
				})
		});
	}

	updateResultValues() {
		const subTotal = [].reduce.call(this.elValues, (acc, el) => {
			return acc + (parseFloat(el.dataset.value))
		}, 0)
		this.elResult.innerHTML = subTotal.toFixed(2).replace('.', ',') + ' ' + this.currencySymbol
	}
}

export default AsyncShippingChecks